import { render } from "./BarraContatoFixa.vue?vue&type=template&id=5fcd2ad1&scoped=true"
import script from "./BarraContatoFixa.vue?vue&type=script&lang=js"
export * from "./BarraContatoFixa.vue?vue&type=script&lang=js"

import "./BarraContatoFixa.vue?vue&type=style&index=0&id=5fcd2ad1&scoped=true&lang=css"
import "./BarraContatoFixa.vue?vue&type=style&index=1&id=5fcd2ad1&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcd2ad1"]])

export default __exports__